export default {
  updatePassword: {
    isLoading: false,
    error: {}
  }
};
